module.exports = __webpack_public_path__ + "static/images/how-it-works-2.0c42fca6e6c5ea0922cc725e00524a5e.png";